import React, { useState, useCallback, useContext, useEffect } from 'react';
import {
  GridContainer,
  Row,
  Column,
  Typography,
  BoundedContent,
} from '@vp/swan';
import { ActiveCartControl } from './ActiveCartControl';
import useSiteData from '../../hooks/useSiteData';
import { CartApplication } from '../CartApplication';
import { UserFeatureContext } from '../contexts/UserFeatureContext';

export const InternalViewCartSession = () => {
  const { vistacartTenant, locale } = useSiteData();
  const [internalViewerSuppliedShopperId, setShopperIdToView] = useState(null);
  const { debugEnabled, setDebugEnabled } = useContext(UserFeatureContext);

  // Set the Debug Mode to enabled when in Internal View
  useEffect(() => {
    if (!debugEnabled) setDebugEnabled(true);
    // Ignoring exhaustive dependencies since we want to ensure this is set true only at component mount time.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const setInternalCartViewShopperId = useCallback(
    ({ shopperId }) => {
      if (shopperId !== internalViewerSuppliedShopperId)
        setShopperIdToView(shopperId);
    },
    [internalViewerSuppliedShopperId, setShopperIdToView]
  );

  const showInternalViewCart = internalViewerSuppliedShopperId !== null;

  return (
    <GridContainer>
      <BoundedContent>
        <Row marginTop="7" marginBottom="2">
          <Column span={6} push={3}>
            <Typography>
              Welcome to Cart Internal View. Enter a Shopper ID to get started.
            </Typography>
          </Column>
        </Row>
        <Row marginBottom="7">
          <Column span={6} push={3}>
            <ActiveCartControl
              setInternalCartViewShopperId={setInternalCartViewShopperId}
            />
          </Column>
        </Row>
        {showInternalViewCart && (
          <CartApplication
            tenant={vistacartTenant}
            shopperId={internalViewerSuppliedShopperId}
            locale={locale}
          />
        )}
      </BoundedContent>
    </GridContainer>
  );
};
